"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * @author yuqzho@microsoft.com, Ning Tang
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.failedToUpdateCustomApiTemplateErrorName = exports.declarativeAgentExistingApiSpecUrlTelemetryEvent = exports.defaultDeclarativeAgentActionId = exports.defaultDeclarativeAgentManifestFileName = void 0;
exports.defaultDeclarativeAgentManifestFileName = "declarativeAgent.json";
exports.defaultDeclarativeAgentActionId = "action_1";
exports.declarativeAgentExistingApiSpecUrlTelemetryEvent = "copilot-plugin-existing-api-spec-url";
exports.failedToUpdateCustomApiTemplateErrorName = "failed-to-update-custom-api-template";
//# sourceMappingURL=const.js.map